import React, { useState } from "react";
import {
  LoadingPopUp,
  ProfileHeader,
  ProfilePopUpDisplay,
  VehicleDisplayCrossModule,
} from "../../common-components";
import { colors } from "../../../themes/Colors";
import { BuzzPcDisplay, Menu, NotificationPcDisplay } from "./components";

const PcModule = ({
  width,
  height,
  liveFeed,
  historyFeed,
  auth,
  user,
  shareAccount,
  setConfirmShareAccount,
  confirmShareAccount,
  CreateShareAccount,
  businessData,
  setLoading,
  refresh,
  setRefresh,
  setModulePopUp,
  modulePopUp,
  AdminNavigate,
  adminRole,
  agencyRole,
  setPopUpTitle,
  setToastPop,
  setMessage,
  invitesArray,
  getUserInvites,
  privateInformation,
}) => {
  const [profileDisplay, setProfileDisplay] = useState(false);
  const [currentDisplay, setCurrentDisplay] = useState("buzz");
  const [vehicleAdd, setVehicleAdd] = useState(null);
  const [vehicleManageView, setVehicleManageView] = useState(null);
  return (
    <div
      style={{
        height: height,
        width: width,
        overflow: "hidden",
        display: "flex",
      }}
    >
      <Menu
        onNoticeClick={() => setCurrentDisplay("notice")}
        onBuzzClick={() => setCurrentDisplay("buzz")}
        onMoreClick={() => setCurrentDisplay("more")}
        onVehicleClick={() => setCurrentDisplay("vehicle")}
        selected={currentDisplay}
      />

      <div
        style={{
          flex: 1,

          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <ProfileHeader
          isCustomer={true}
          backgroundColor={colors.greenDark}
          username={
            auth
              ? auth.customerUserData.firstName +
                " " +
                auth.customerUserData.lastName
              : "loading"
          }
          onProfileClick={() =>
            setProfileDisplay(profileDisplay ? false : true)
          }
        />
        {currentDisplay === "notice" ? (
          <NotificationPcDisplay
            setLoading={setLoading}
            setPopUpTitle={setPopUpTitle}
            setToastPop={setToastPop}
            setMessage={setMessage}
            setRefresh={setRefresh}
            refresh={refresh}
            getUserInvites={getUserInvites}
            auth={auth}
            invitesArray={invitesArray}
          />
        ) : null}
        {currentDisplay === "buzz" ? (
          <BuzzPcDisplay
            setLoading={setLoading}
            setPopUpTitle={setPopUpTitle}
            setToastPop={setToastPop}
            setMessage={setMessage}
            setRefresh={setRefresh}
            refresh={refresh}
            auth={auth}
            liveFeed={liveFeed}
            historyFeed={historyFeed}
          />
        ) : null}

        {currentDisplay === "vehicle" ? (
          <VehicleDisplayCrossModule
            setLoading={setLoading}
            setPopUpTitle={setPopUpTitle}
            setToastPop={setToastPop}
            setMessage={setMessage}
            setRefresh={setRefresh}
            refresh={refresh}
            auth={auth}
            width={width}
            setAddVehiclePopUp={setVehicleAdd}
            vehicleAdd={vehicleAdd}
            user={user}
            type={"consumer"}
            privateInformation={privateInformation}
            height={height}
          />
        ) : null}
        <ProfilePopUpDisplay
          businessData={businessData}
          shareAccount={shareAccount}
          auth={auth}
          user={user}
          profileDisplay={profileDisplay}
          setProfileDisplay={setProfileDisplay}
          setConfirmShareAccount={setConfirmShareAccount}
          confirmShareAccount={confirmShareAccount}
          CreateShareAccount={CreateShareAccount}
          setLoading={setLoading}
          refresh={refresh}
          setRefresh={setRefresh}
          setModulePopUp={setModulePopUp}
          modulePopUp={modulePopUp}
          AdminNavigate={AdminNavigate}
          adminRole={adminRole}
          agencyRole={agencyRole}
          privateInformation={privateInformation}
        />
      </div>
    </div>
  );
};

export default PcModule;
